export default __webpack_public_path__ + "static/media/architecture-selected.d7b8928a.svg";